import { openLinkIcon } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { NavLink } from "react-router";

export const InternalLink = ({
  children,
  to,
  onClick,
  truncate = false,
}: {
  children: React.ReactNode;
  to: string;
  onClick?: (e: React.MouseEvent) => void;
  /** Cuts the text with an ellipsis instead of wrapping, icon kept whole. */
  truncate?: boolean;
}) => {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={cn(
        "inline-flex underline text-dark-link hover:text-dark-link-hover flex-row items-center gap-x-1",
        truncate && "min-w-0",
      )}
    >
      {truncate ? <span className="truncate">{children}</span> : children}
      <div className="w-3 h-3 shrink-0">{openLinkIcon}</div>
    </NavLink>
  );
};
